import { Badge } from "flowbite-react";

type ClassifiedAdsUnreadBadgeProps = {
  count: number
  testId?: string
};

export const ClassifiedAdsUnreadBadge = ({
  count,
  testId = "classified-ads-unread-total",
}: ClassifiedAdsUnreadBadgeProps) => {
  if (count === 0) return null;

  return (
    <Badge
      color="pink"
      data-testid={testId}
      className="ml-auto flex h-5 min-w-[1.25rem] items-center justify-center rounded-full px-1.5 text-xs font-semibold"
    >
      {count > 99 ? "99+" : count}
    </Badge>
  );
};

ClassifiedAdsUnreadBadge.displayName = "ClassifiedAdsUnreadBadge";
